import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

const ProgressBar = ({ label, value }) => (
  <Box
    sx={{
      borderBottom: 1,
      borderBottomColor: 'graphic.light',
      p: 3,
      width: '100%',
    }}
  >
    <LinearProgress
      data-variant="magellanProgressBar"
      sx={{
        '&.MuiLinearProgress-colorPrimary > .MuiLinearProgress-bar': {
          borderRadius: '10px',
        },
      }}
      value={value}
      variant="determinate"
    />
    <Typography>{label}</Typography>
  </Box>
);

ProgressBar.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};

export default ProgressBar;
